module.exports = __webpack_public_path__ + "img/KaiLiPhD.9e8fddd1.png";